/*
=========================================================
* Material Kit 2 PRO React - v2.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function ChatFlowInfo() {
  const data = [
    {
      icon: "psychology", // Icon for AI/decision making
      title: "Agent 1 – Conversatiecontrole",
      items: [
        "Ontvangt het laatste gebruikersbericht.",
        "Beslist of het bericht sociaal of data-gericht is.",
        "Is het sociaal? Formuleer direct een vriendelijk antwoord voor de frontend, bijvoorbeeld: 'Graag gedaan, kan ik verder nog iets doen?'",
        "Is er informatie uit de kennisbank nodig? Stuur het gesprek door naar Agent 2",
      ],
    },
    {
      icon: "search", // Icon for searching/checking knowledge base
      title: "Agent 2 – Kennisbank-check",
      items: [
        "Zoekt in de kennisbank en beoordeelt: staat het antwoord erin of niet?",
        "Geen antwoord gevonden? Activeer op de frontend 'Ik weet het niet'-dialoog",
        "Antwoord gevonden? Stuur door naar Agent 3",
      ],
    },
    {
      icon: "smart_toy", // Icon for AI response generation
      title: "Agent 3 – Antwoordgenerator",
      items: [
        "Raadpleegt opnieuw de kennisbank",
        "Formuleert een volledig antwoord en stuurt dit terug naar de frontend voor weergave aan de gebruiker.",
      ],
    },
    {
      icon: "waving_hand",
      title: "Agent 4 – Gesprek afronden",
      items: [
        "Agent 4 wordt aangeroepen zodra de lengte van het gesprek over het maximaal aantal tokens komt.",
        "Herformuleert het antwoord om duidelijk te maken dat het gesprek is afgerond.",
      ],
    },
  ];

  return (
    <MKBox component="section" py={12} px={1}>
      <Container>
        <Grid container item xs={12} lg={8}>
          <MKTypography variant="h3">Chat-flow in vier stappen</MKTypography>
          <MKTypography variant="body2" fontWeight="regular" color="text">
            De chatbot bestaat uit vier agents die elk verantwoordelijk zijn voor een deel van de
            logica. Het bericht van de gebruiker komt binnen bij Agent 1. Iedere stap maakt een
            beslissing op basis van zijn instructies en stuurt dan een antwoord terug naar de
            gebruiker of stuurt het gesprek verder naar de volgende chatbot.
          </MKTypography>
        </Grid>
        <Grid container sx={{ mt: 6 }}>
          {data.map(({ icon, title, items }) => (
            <Grid key={icon} item xs={12} md={4}>
              <MKBox py={2} pr={2}>
                <MKTypography variant="h3" color="info">
                  <Icon>{icon}</Icon>
                </MKTypography>
                <MKTypography variant="h5" mt={2} mb={3}>
                  {title}
                </MKTypography>
                {items.map((item) => (
                  <MKBox key={item} display="flex" lineHeight={1.25}>
                    <MKTypography variant="body1" color="info">
                      <Icon sx={{ fontWeight: "bold" }}>done</Icon>
                    </MKTypography>
                    <MKBox pl={2}>
                      <MKTypography variant="button" color="text" fontWeight="bold">
                        {item}
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                ))}
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ChatFlowInfo;
